import { FC } from 'react';

interface ActiveInfoPopoverProps {
    children: React.ReactNode;
    title: string;
    type: string;
    tab?: any;
    tabsInside?: any;
    groupColor?: string;
    groupEmoji?: string;
    groupIsOpen?: boolean;
    keepClosed?: boolean;
    insideGroup?: boolean;
    index?: number;
    windowId?: number;
}

const ActiveInfoPopover: FC<ActiveInfoPopoverProps> = ({
    children,
    title,
    type,
    tab = null,
    tabsInside = null,
    groupColor = null,
    groupEmoji = null,
    groupIsOpen = false,
    keepClosed = false,
    insideGroup = false,
    index,
    windowId = null
}) => {
    return <div></div>;
};

export default ActiveInfoPopover;
